import { ENewbuildingPolygonActionType } from './types';
import { IActiveNewbuildingPolygon } from '../../types/map/newbuildingPolygon';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setActiveNewbuildingPolygon = actionGenerator<
  ENewbuildingPolygonActionType.NewbuildingPolygonSelected,
  IActiveNewbuildingPolygon
>(ENewbuildingPolygonActionType.NewbuildingPolygonSelected);
